import { useState } from 'react';
import { Input } from '@/components/ui/input';

interface OptionsEditorProps {
  options: string[];
  onChange: (next: string[]) => void;
}

export function OptionsEditor({ options, onChange }: OptionsEditorProps) {
  const [draft, setDraft] = useState('');

  function add() {
    const v = draft.trim();
    if (!v) return;
    if (options.includes(v)) {
      setDraft('');
      return;
    }
    onChange([...options, v]);
    setDraft('');
  }

  return (
    <div className="mt-3 rounded border border-dashed border-gray-200 bg-gray-50/60 p-2">
      <div className="flex flex-wrap items-center gap-1.5">
        {options.length === 0 ? (
          <span className="text-[11px] text-gray-500">No options yet — add at least one.</span>
        ) : (
          options.map((opt, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-xs text-gray-800 ring-1 ring-gray-200"
            >
              {opt}
              <button
                type="button"
                onClick={() => onChange(options.filter((_, j) => j !== i))}
                className="text-gray-400 hover:text-red-600"
                aria-label={`Remove ${opt}`}
              >
                ×
              </button>
            </span>
          ))
        )}
      </div>
      <div className="mt-2 flex items-center gap-2">
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
          placeholder="Type an option, press Enter"
        />
        <button
          type="button"
          onClick={add}
          className="shrink-0 rounded-md border border-gray-300 bg-white px-2 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50"
        >
          Add
        </button>
      </div>
    </div>
  );
}
